import React from 'react';
import { NavLink } from 'react-router-dom';
import './Payment.css';

const PaymentCancel = () => {
    return (
        <div className="payment-page">
            <div className="payment-card">
                <div className="payment-status-icon">!</div>
                <p className="payment-eyebrow">Checkout cancelled</p>
                <h1>Payment was not completed</h1>
                <p className="payment-message muted">
                    You can choose a plan again whenever you are ready.
                </p>
                <div className="payment-actions">
                    <NavLink to="/#pricing-heading" className="payment-primary-link">Choose plan</NavLink>
                    <NavLink to="/" className="payment-secondary-link">Back to home</NavLink>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancel;
